import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCol,
    IonContent,
    IonIcon,
    IonPage,
    IonRow
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Competition } from "../../../../../../models";
import Header from "../../../../../../components/Headers/Header";
import PageTitle from "../../../../../../components/PageTitle/PageTitle";
import { getCompetitionsByStatus } from "../../../../../../utilities/competition/Competition";
import Spinner from "../../../../../../components/Spinners/Spinner";
import { Table } from "reactstrap";
import { formatStartEndDatesStrings } from "../../../../../../utilities/dates/FormatDates";
import { mailSharp } from "ionicons/icons";
import { generateAELCompetitionInvitationReport } from "../../../../../../utilities/reports/CompetitionReport";
import { formatShortAddress } from "../../../../../../utilities/address/FormatAddress";
import moment from "moment";
import ErrorBanner from "../../../../../../components/Banners/ErrorBanner";
import { getCompetitionStatus, getCompetitionStatusColor } from "../../../../../../utilities/competition/CompetitionUtils";

const AllCompetitionsPage: React.FC = () => {
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        getCompetitions();
    }, []);

    const getCompetitions = async () => {
        setIsLoading(true);
        setError("");

        let list: Competition[] = [];

        const competitionQuery = await getCompetitionsByStatus("published");
        if (competitionQuery.isSuccess) {
            list = list.concat(competitionQuery.result);
        }
        const cancelledCompetitionQuery = await getCompetitionsByStatus("cancelled");
        if (cancelledCompetitionQuery.isSuccess) {
            list = list.concat(cancelledCompetitionQuery.result);
        }

        const sorted = list.sort((a,b) => {
            const aDate: any = moment(a.startDate || "").format("YYYYMMDDHHmmss")
            const bDate: any = moment(b.startDate || "").format("YYYYMMDDHHmmss");
            return bDate - aDate;
        });

        setCompetitions(sorted);
        setIsLoading(false);
    }

    const formatCompetitionStatusString = (c: Competition) => {
        const string = getCompetitionStatus(c);
        return string;
    }

    const formatCompetitionStatusColor = (c: Competition) => {
        const color = getCompetitionStatusColor(c);
        return color;
    }

    const createCompetitionInvitation = async (selectedCompetition: Competition) => {
        if (selectedCompetition) {
            setIsLoading(true); 
            await generateAELCompetitionInvitationReport(selectedCompetition, true);
            setIsLoading(false);
        }
        else setError("No competition found. Cannot generate report.");
    }

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="AEL Competitions" />
                {error && <ErrorBanner error={error} />}
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <p>View the AEL approved competitions below and download their Invitations to view more information about them.</p>
                            {isLoading ?
                                <Spinner />
                                :
                                <IonCardContent>
                                    {(competitions && competitions.length > 0) ?
                                        <Table responsive striped hover>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <p className="ion-text-wrap">Comp Date</p>
                                                    </th>
                                                    <th>
                                                        <p className="ion-text-wrap">Comp Name</p>
                                                    </th>
                                                    <th>
                                                        <p className="ion-text-wrap">Location</p>
                                                    </th>
                                                    <th>
                                                        <p className="ion-text-wrap">Status</p>
                                                    </th>
                                                    <th>
                                                        <p className="ion-text-wrap">Invitation</p>
                                                    </th>
                                                    <th>
                                                        <p className="ion-text-wrap">Comp Last Updated</p>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {competitions.map((c, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <p className="ion-text-wrap">{c.startDate ? formatStartEndDatesStrings(c.startDate) : ""}</p>
                                                        </td>
                                                        <td>
                                                            <p className="ion-text-wrap">{c.name}</p>
                                                        </td>
                                                        <td>
                                                            <p className="ion-text-wrap">{c.address ? formatShortAddress(c.address) : ""}</p>
                                                        </td>
                                                        <td>
                                                            <p className={("ion-text-wrap text-" + formatCompetitionStatusColor(c))}>{formatCompetitionStatusString(c)}</p>
                                                        </td>
                                                        <td>
                                                            <p className="ion-text-wrap link">
                                                                <IonButton color="tertiary" onClick={() => createCompetitionInvitation(c)}>
                                                                    <p><IonIcon icon={mailSharp}/> Invitation</p>
                                                                </IonButton>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p className="ion-text-wrap">{c.updatedOn ? moment(c.updatedOn).format("MM/DD/YY hh:mm a") : ""}</p>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        :
                                        <p>No competitions were found.</p>
                                    }
                                </IonCardContent>
                            }
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default AllCompetitionsPage;